import { ReactNode } from "react";

export interface DeleteButtonProps {
    title: string;
    outlined?: boolean;
    textSize?: 'm' | 'l';
    onClick: (e: any) => void;
    icon?: ReactNode
}

export const DeleteButton: React.FC<DeleteButtonProps> = (btn) => {
    return (
        <div className="w-full h-fit">
            <button className={`w-full px-2 text-red-500 ${btn.outlined ? "border-2 border-red-500 py-1.5 hover:bg-red-500 hover:text-white" : "ring-0 bg-red-500 text-white py-2"} ${btn.textSize == 'l' ? 'text-lg lg:text-xl' : ''} font-medium rounded-xl shadow-main hover:red-600 transition duration-150 flex flex-row justify-center items-center`}
            onClick={btn.onClick}>
                {btn.icon && 
                <div className="h-[26px] w-[26px] mr-1 z-20">
                    {btn.icon}
                </div>
                }
                <div>
                    {btn.title}
                </div>
            </button>
        </div>
    )
}